<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="quick-title-wrapper">
        <div class="quick-title">{{L.bankInfo}}</div>
      </div>
      <div class="inp-wrapper">
        <div class="warning">
          <span class="iconfont icon-warning">&#xe6aa;</span>
          <span class="warning-text">{{L.bankNotice}}</span>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.companyAccountName}}:</div>
          <div class="inp">{{obj.accountName}}</div>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.bankAccountNumber}}:<span class="asterisk">*</span></div>
          <el-input size="mini" class="inp" v-model="obj.bankAccount"></el-input>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.areaBank}}:<span class="asterisk">*</span></div>
          <el-cascader
            class="inp"
            popper-class="auth-cascader"
            :filterable="true"
            clearable
            size="mini" 
            v-model="area"
            :options="areaList"
            @change="handleChangeArea">
          </el-cascader>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.bankName}}:<span class="asterisk">*</span></div>
          <el-select popper-class="auth-select" size="mini" class="inp" v-model="obj.bankName" filterable @change="handleChangeBank">
            <el-option
              v-for="item in bankList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="inp-wrap">
        <div class="title">{{L.fullNameBank}}:<span class="asterisk">*</span></div>
          <el-select popper-class="auth-select" size="mini" class="inp" v-model="obj.bankFullname" filterable>
            <el-option
              v-for="item in branckBankList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>  
      </div>
      <div class="btn-wrapper">
        <div class="btn-wrap" @click="handleConfirm" v-loading="loading">
          <span>{{L.confirm}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api_auth_bank_info_confirm,api_china_area,api_bank_list_by_city,api_branch_bank_list} from '@/api/api'
import {postAction} from '@/api/tool'

export default {
  name:'Bank',
  data() {
    return {
      loading:false,
      show:false,
      areaList:[],
      bankList:[],
      branckBankList:[],
      area:'',
      obj:{
        accountName:'',
        bankAccount:'',
        province:'',
        city:'',
        bankName:'',
        bankFullname:''
      }
    }
  },
  methods:{
    open(obj){
      this.obj={
        accountName:obj.accountName,
        bankAccount:obj.bankAccount,
        province:obj.province,
        city:obj.city,
        bankName:obj.bankName,
        bankFullname:obj.bankFullname
      }
      this.area=[obj.province,obj.city]
      this.show=true
      this.getArea()
      this.getBank()
      this.getBranchBank()
    },
    close(){
      this.show=false
    },
    getArea(){
      postAction(api_china_area).then(res=>{
        this.areaList=res
      })
    },
    handleChangeArea(e){
      this.area=e
      this.obj.province=e[0]
      this.obj.city=e[1]
      this.obj.bankName=''
      this.obj.bankFullname=''
      this.getBank()
    },
    getBank(){
      if(this.area.length==0){
        this.bankList=[]
        return
      }
      let params = {
        province:this.area[0],
        city:this.area[1]
      }
      postAction(api_bank_list_by_city,params).then(res=>{
        this.bankList=res.bankList
      })
    },
    handleChangeBank(e){
      this.obj.bankName=e
      this.obj.bankFullname=''
      this.getBranchBank()
    },
    getBranchBank(){
      if(this.area.length==0 || !this.obj.bankName){
        this.branckBankListList=[]
        return
      }
      let params = {
        province:this.area[0],
        city:this.area[1],
        bankName:this.obj.bankName
      }
      postAction(api_branch_bank_list,params).then(res=>{
        this.branckBankList=res.depBankList
      })
    },
    handleConfirm(){
      if(!this.obj.bankAccount){
        this.$message.warning('Please enter the bank account number')
        return
      }
      if(this.area.length==0){
        this.$message.warning('Please select the area of bank')
        return
      }
      if(!this.obj.bankName){
        this.$message.warning('Please enter the bank name')
        return
      }
      if(!this.obj.bankFullname){
        this.$message.warning('Please enter the full name of the bank branch')
        return
      }
      
      this.loading=true
      postAction(api_auth_bank_info_confirm,this.obj).then(()=>{
        this.loading=false
        this.$message.success('Saved successfully')
        this.close()
        this.$emit('getAuth')
      }).catch(()=>{
        this.loading=false
      })
      
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    padding:30px 0;
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .quick-title-wrapper{
      padding:0 40px 20px 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 26px;
      color:@mainColor;
      border-bottom: 1px solid @inpBorderClolr;
      // padding-bottom: 20px;
      // padding-top: 10px;
      .quick-title{
        // background-color: red;
        text-align: center;
      }
    }
    .inp-wrapper{
      padding:0 40px;
      .warning{
        color:@mainColor;
        margin-bottom: 18px;
        .icon-warning{

        }
        .warning-text{
          font-size: 12px;
          margin-left: 10px;
        }
      }
      .inp-wrap{
        font-size: 12px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .title{
          text-align: right;
          width:160px;
          margin-right: 20px;
          .asterisk{
            color:@dangerColor;
            font-size: 12px;
            margin-left: 6px;
          }
        }
        .inp{
          flex: 1;
          color:@inpNumColor;
        }
      }
    }
    .btn-wrapper{
      padding:0 40px;
      .btn-wrap{
        font-size: 12px;
        margin-top: 26px;
        text-align: center;
        width:100%;
        color:#fff;
        background-color: @mainColor;
        padding:8px 6px;
        box-sizing: border-box;
        border:1px solid @mainColor;
        border-radius: 2px;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          color:@mainColor;
          background-color: #fff;
          &:extend(.transtion-time);
        }
      }
    }
  }
}
</style>